import { Control, Controller, FieldValues, Path } from 'react-hook-form';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useUnits } from '@/hooks/use-units';
import { MeasurementSystem, UnitType } from '@/types';

interface UnitSelectProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  unitType: UnitType[];
  disabled?: boolean;
  measurementSystem: MeasurementSystem;
}

export function UnitSelect<T extends FieldValues>({
  name,
  control,
  unitType,
  disabled,
  measurementSystem,
}: UnitSelectProps<T>) {
  const { units } = useUnits(unitType, measurementSystem);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Select
          value={field.value}
          onValueChange={field.onChange}
          disabled={disabled}
        >
          <SelectTrigger className="h-full w-16 border-0 border-l rounded-l-none bg-transparent focus:outline-none focus:shadow-none focus:ring-0 focus:ring-offset-0">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {units.map((u) => (
              <SelectItem key={u.code} value={u.code}>
                {u.code}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    />
  );
}
